import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import { useScreen } from '../../../../../hooks'
import {
  FlatSelect,
  getFlatSelectFormikFieldControlDisabledProps,
} from '../../../../Flat'
import { FormFieldSelectNG } from '../../../../Form'
import { FormikField, getFormikFormFieldErrorProps } from '../../../../Formik'
import {
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING,
  REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT,
} from '../../RequestWizardForm.constants'

import { getFlatApiParams } from './FlatField.utils'

import * as styles from '../RequestWizardInitStageFormFields.module.css'

function FlatField({
  apiParams,
  isFilledAddressDisabled,
  isLoading,
  required,
  onClear,
  ...restProps
}) {
  const { t } = useTranslation()

  const { values } = useFormikContext()

  const { isMobileScreenSize } = useScreen() // TODO make same by css media instead of useScreen

  const flatApiParams = { ...apiParams, ...getFlatApiParams(values) }

  function handleClear() {
    onClear?.()
  }

  function handleChange() {
    onClear?.()
  }

  return (
    <FormikField
      {...restProps}
      Component={FormFieldSelectNG}
      Select={FlatSelect}
      apiParams={flatApiParams}
      controlProps={{
        borderless: !isMobileScreenSize,
        className: isFilledAddressDisabled
          ? styles.disabledPointerEvents
          : undefined,
        contentProps: {
          inputProps: {
            placeholder: t('Wizard.FlatPlaceholderKey'),
          },
        },
        indicatorsProps: isFilledAddressDisabled
          ? {
              ButtonArrow: null,
              ButtonClear: null,
            }
          : undefined,
      }}
      disabled={
        isLoading || !values[REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_BUILDING]
      }
      fieldComponentProps={{
        disabled: isLoading,
        label: `${t('Wizard.FlatLabelKey')}:`,
        required,
        shouldAdaptToMobileScreen: true,
      }}
      getErrorProps={getFormikFormFieldErrorProps}
      getFieldDisabledProps={getFlatSelectFormikFieldControlDisabledProps}
      name={REQUEST_WIZARD_INIT_STAGE_FIELD_NAME_FLAT}
      onChange={handleChange}
      onClear={handleClear}
    />
  )
}

export default FlatField
